import client from "@/client";

import imageUrlBuilder from "@sanity/image-url";

export default function imgUrlFor(source: any) {
	return imageUrlBuilder(client).image(source);
}
